module.exports = Marionette.Behavior.extend( {
	ui: {
		insertButton: '.kitbuilder-template-library-template-insert'
	},

	events: {
		'click @ui.insertButton': 'onInsertButtonClick'
	},

	onInsertButtonClick: function() {
		var action = this.ui.insertButton.data( 'action' );

		if ( 'insert' === action ) {
			kitbuilder.templates.importTemplate( this.view.model );
		} else {
			open( kitbuilder.config.pro_library_url, '_blank' );
		}
	}
} );
